/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 */

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { attemptChunkReload } from '@app/core/chunk-recovery';
import { initDatadogMonitoring } from '@app/core/datadog';
import { Logger } from '@app/core/logger.service';
import { environment } from '@env/environment';

const lintLogger = new Logger('main');

if (environment.production) {
  enableProdMode();
  initDatadogMonitoring('hypecast.one');
}

if (environment.environmentName === 'QA') {
  initDatadogMonitoring('hypecast.dev');
}

const bootstrap = () => bootstrapApplication(AppComponent, appConfig);

// Recovery for stale lazy chunks after a deploy. Detection + the loop-guarded
// reload live in @app/core/chunk-recovery so this file and the Angular
// ErrorHandler share exactly one implementation.
window.addEventListener(
  'error',
  (event) => {
    const target = event.target as HTMLElement;
    const isResourceLoadError = target?.tagName === 'SCRIPT' || target?.tagName === 'LINK';
    const reason = isResourceLoadError ? { message: 'Failed to load module script' } : { message: event.message };

    if (attemptChunkReload(reason)) {
      lintLogger.warn('Chunk/resource load error detected, reloading page...');
    }
  },
  true,
);

window.addEventListener('unhandledrejection', (event) => {
  if (attemptChunkReload(event.reason)) {
    lintLogger.warn('Dynamic import failed, reloading page...');
    event.preventDefault();
  }
});

fetch('/version.json?_t=' + Date.now())
  .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
  .then((info: { version: string; hash: string; buildTime: string }) => {
    // eslint-disable-next-line no-console
    console.log(
      `%c Hypecast Admin v${info.version} (${info.hash}) — built ${info.buildTime} `,
      'background:#0029FF;color:#fff;border-radius:3px;padding:2px 6px',
    );
  })
  .catch(() => {
    // version.json is optional in local development.
  });

bootstrap().catch((err) => lintLogger.error(err));
